export function clearActiveFocus(): void {
    const activeElement = document.activeElement as HTMLElement | null;

    if (activeElement && typeof activeElement.blur === 'function') {
        activeElement.blur();
    }
}